import { render, staticRenderFns } from "./viewStatus.vue?vue&type=template&id=78bf7874&"
import script from "./viewStatus.vue?vue&type=script&lang=js&"
export * from "./viewStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports